import lang from "../assets/images/flags/lang.json";
import { Link } from "react-router-dom";
import Icons from "./images/Icons";
import APP from "../common/app";
import { useDispatch, useSelector } from "react-redux";
import { footerActiveMenu } from "../features/reducers/global";
import { useEffect, useState } from "react";

const Footer = () => {
  /*Store*/
  const active = useSelector(footerActiveMenu);
  const [langParam, setLangParam] = useState("TH");
  const [userCountry, setUserCountry] = useState("");

  const initialSelectedOption = localStorage.getItem("selectedOption") || "TH";

  useEffect(() => {
    if (initialSelectedOption === "TH") {
      setLangParam("TH");
    } else if (initialSelectedOption === "US") {
      setLangParam("US");
    } else if (initialSelectedOption === "VN") {
      setLangParam("VN");
    } else if (initialSelectedOption === "LA") {
      setLangParam("LA");
    } else if (initialSelectedOption === "CN") {
      setLangParam("CN");
    } else if (initialSelectedOption === "KR") {
      setLangParam("KR");
    }
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("lang", initialSelectedOption);
    window.history.replaceState({}, "", newUrl.toString());
  }, [initialSelectedOption]);

  document.body.classList.add("dashboard");

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="row align-items-center">
          <div className={`col text-center ${active === `slot` && `active`}`}>
            <Link to={`/slot`}>
              <div className="mb-0">
                <img
                  src={Icons.slot}
                  alt=""
                  style={{ width: 34, height: 34 }}
                />
              </div>
              {lang.footer[langParam]["slot"]}
            </Link>
          </div>
          <div className={`col text-center ${active === `casino` && `active`}`}>
            <Link to={`/casino`}>
              <div className="mb-0">
                <img src={Icons.casino} alt="" />
              </div>
              {lang.footer[langParam]["casino"]}
            </Link>
          </div>
          <div className="col wallet text-center">
            <Link to={`/dashboard`} className="wallet-icon">
              <div className="text-center">
                <div className="logo-light">
                  <img
                    src={APP.logoLight}
                    alt="logo-light"
                  />
                </div>
                <span>{lang.footer[langParam]["wallet"]}</span>
              </div>
            </Link>
          </div>
          <div className={`col text-center ${active === `lotto` && `active`}`}>
            <Link to={`/lotto`}>
              <div className="mb-0">
                <img
                  src={Icons.lotto}
                  alt=""
                  style={{ width: 34, height: 34 }}
                />
              </div>
              {lang.footer[langParam]["lotto"]}
            </Link>
          </div>
          <div className={`col text-center ${active === `sport` && `active`}`}>
            <Link to={`/sport`}>
              <div className="mb-0">
                <img
                  src={Icons.sport}
                  alt=""
                  style={{ width: 34, height: 34 }}
                />
              </div>
              {lang.footer[langParam]["sport"]}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
